"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Arrowleft = function Arrowleft(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ArrowleftTitle ArrowleftDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ArrowleftTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ArrowleftDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M6.895 11.15l12.234-.008c.223 0 .446.084.616.252.34.335.34.88 0 1.215a.874.874 0 0 1-.616.252H6.905l3.723 3.673a.87.87 0 0 1 0 1.216.872.872 0 0 1-.616.253.872.872 0 0 1-.616-.253l-5.1-5.043a.99.99 0 0 1 0-1.412l5.098-5.043A.874.874 0 0 1 10.01 6c.481 0 .871.385.871.86a.851.851 0 0 1-.255.608l-3.73 3.682z",
    id: "refArrowleftPJf1VowcvC"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refArrowleftPJf1VowcvC"
  }));
};

Arrowleft.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Arrowleft.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Arrowleft;
exports["default"] = _default;